export default "__VITE_ASSET__DAD5V2xe__"